// extracted by mini-css-extract-plugin
export default {"cart-summary-container":"styles_cart-summary-container__UO+Bo","fullView":"styles_fullView__gPKsu","shimmer":"styles_shimmer__fZCex"};